import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import {
  COMMON_PERMISSIONS,
  MODULES_LIST,
  SUB_MODULES_LIST,
} from "../../../utils/helper";
import CategoriesDetail from "../../main/inventory/categories/categoryDetail/page";
import PurchaseOrder from "../../main/inventory/purchaseOrder/page";
import AddPurchaseOrder from "../../main/inventory/purchaseOrder/addPurchaseOrder";
import CreatePurchaseInvoice from "../../main/inventory/purchaseOrder/createPurchaseInvoice";
import PurchaseRequest from "../../main/inventory/purchaseRequest/page";
import AddPurchaseRequest from "../../components/forms/inventory/addPurchaseRequest";
import Stock from "../../main/inventory/stock/page";
import AddStock from "../../main/inventory/stock/addStock";
// import DetailStock from "../../main/inventory/stock/detailsView/page";
// import StockOverview from "../../main/inventory/stock/detailsView/innerPages/overview/page";
// import AssignStock from "../../main/inventory/stock/detailsView/innerPages/assignStock/page";
// import StockHistory from "../../main/inventory/stock/detailsView/innerPages/StockHistory/page";
// import EditStockForm from "../../components/forms/inventory/editStockForm";
import Vendor from "../../main/inventory/vendor/page";
import AddVendors from "../../main/inventory/vendor/addVendors";
// import VendorsDetail from "../../main/inventory/vendor/profile/page";
// import VendorsDetailOverview from "../../main/inventory/vendor/profile/innerPages/overview/page";
// import VendorDocument from "../../main/inventory/vendor/profile/innerPages/vendorDocument/page";
// import VendorPurchaseOrder from "../../main/inventory/vendor/profile/innerPages/vendorPurchaseOrder/page";
// import VendorPurchaseInvoice from "../../main/inventory/vendor/profile/innerPages/vendorPurchaseInvoice/page";
import PurchaseInvoice from "../../main/inventory/purchaseInvoices/page";
import ManageCategory from "../../main/inventory/categories/page";
import VendorProfile from "../../main/inventory/vendor/profile/profile";
import StockDetail from "../../main/inventory/stock/profile/stockDetail";
import CategoryDetail from "../../main/inventory/categories/categoryDetail/page";

const inventoryRoutes = [
  {
    path: "/inventory/category",
    element: <ManageCategory />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.INVENTORY,
    // subModule: SUB_MODULES_LIST.INVENTORY.INVENTORY_CATEGORY,
  },
  {
    path: "/inventory/category/detail/:id?",
    element: <CategoryDetail />, 
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.INVENTORY,
    // subModule: SUB_MODULES_LIST.INVENTORY.INVENTORY_CATEGORY,
  },
  {
    path: "/inventory/purchase-order",
    element: <PurchaseOrder />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.PURCHASE_ORDER,
  },
  {
    path: "/inventory/purchase-order/add",
    element: <AddPurchaseOrder />,
    access: [COMMON_PERMISSIONS.CREATE],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.PURCHASE_ORDER,
  },
  {
    path: "/inventory/purchase-order/add/:id",
    element: <AddPurchaseOrder />,
    access: [COMMON_PERMISSIONS.CREATE],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.PURCHASE_ORDER,
  },
  {
    path: "/inventory/purchase-order/create-invoice",
    element: <CreatePurchaseInvoice />,
    access: [COMMON_PERMISSIONS.CREATE],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.PURCHASE_ORDER,
  },
  {
    path: "/inventory/purchase-request",
    element: <PurchaseRequest />,
    access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.INVENTORY,
    // subModule: SUB_MODULES_LIST.INVENTORY.PURCHASE_REQUEST,
  },
  {
    path: "/inventory/purchase-request/add",
    element: <AddPurchaseRequest />,
    access: [COMMON_PERMISSIONS.CREATE],
    // module: MODULES_LIST.INVENTORY,
    // subModule: SUB_MODULES_LIST.INVENTORY.PURCHASE_REQUEST,
  },
  {
    path: "/inventory/stock",
    element: <Stock />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.STOCK,
  },
  {
    path: "/inventory/stock/:action?/:id?",
    element: <AddStock />,
    access: [COMMON_PERMISSIONS.CREATE],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.STOCK,
  },
  {
    path: "/inventory/stock/detail/:id?",
    element: <StockDetail />,
    // access: [COMMON_PERMISSIONS.VIEW],
    // module: MODULES_LIST.INVENTORY,
    // subModule: SUB_MODULES_LIST.INVENTORY.STOCK,
  },
  {
    path: "/inventory/vendor",
    element: <Vendor />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.VENDOR,
  },
  {
    path: "/inventory/vendor/:action?/:id?",
    element: <AddVendors />,
    access: [COMMON_PERMISSIONS.CREATE],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.VENDOR,
  },
  {
    path: "/inventory/vendor/profile/:id/:action",
    element: <AddVendors />,
    access: [COMMON_PERMISSIONS.VIEW, COMMON_PERMISSIONS.UPDATE],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.VENDOR,
  },
  // {
  //   path: "/inventory/vendor/profile",
  //   element: <VendorsDetail />,
  //   access: [COMMON_PERMISSIONS.VIEW],
  //   module: MODULES_LIST.INVENTORY,
  //   subModule: SUB_MODULES_LIST.INVENTORY.VENDOR,
  //   children: [
  //     {
  //       path: ":id",
  //       element: <VendorsDetailOverview />,
  //       access: [COMMON_PERMISSIONS.VIEW],
  //       module: MODULES_LIST.INVENTORY,
  //       subModule: SUB_MODULES_LIST.INVENTORY.VENDOR,
  //     },
  //     {
  //       path: "document/:id",
  //       element: <VendorDocument />,
  //       access: [COMMON_PERMISSIONS.VIEW],
  //       module: MODULES_LIST.INVENTORY,
  //       subModule: SUB_MODULES_LIST.INVENTORY.VENDOR,
  //     },
  //     {
  //       path: "purchase-order/:id",
  //       element: <VendorPurchaseOrder />,
  //       access: [COMMON_PERMISSIONS.VIEW],
  //       module: MODULES_LIST.INVENTORY,
  //       subModule: SUB_MODULES_LIST.INVENTORY.VENDOR,
  //     },
  //     {
  //       path: "purchase-invoices/:id",
  //       element: <VendorPurchaseInvoice />,
  //       access: [COMMON_PERMISSIONS.VIEW],
  //       module: MODULES_LIST.INVENTORY,
  //       subModule: SUB_MODULES_LIST.INVENTORY.VENDOR,
  //     },
  //   ],
  // },
  
  {
    path: "/inventory/vendor/profile/:id?",
    element: <VendorProfile />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.PURCHASE_INVOICE,
  },
  {
    path: "/inventory/purchase-invoice",
    element: <PurchaseInvoice />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.INVENTORY,
    subModule: SUB_MODULES_LIST.INVENTORY.PURCHASE_INVOICE,
  },
];

export default function renderInventoryRoutes() {
  const renderRoute = (route, access = false) => {
    if (route.children && route.children.length > 0) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          }
        >
          {/* Render child routes without extra permission checks */}
          {route.children.map((child) => (
            <Route key={child.path} path={child.path} element={child.element} />
          ))}
        </Route>
      );
    }
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };
  return inventoryRoutes.map((route) => renderRoute(route));
}
